export default function({ props, state, uuid }) {
  state.merge(
    `media.uploading`,
    props.files.reduce((acc, file) => {
      const { name, size } = file
      const id = uuid.id()
      acc[id] = {
        id,
        node: props.node.id,
        path: props.node.path,
        file,
        name: String.prototype.normalize ? name.normalize() : name,
        size,
        percentComplete: 0,
        pending: true
      }
      return acc
    }, {})
  )
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/saveUploadingFilesToState.js